<template>
  <span :class="['cf-badge', tone === 'warn' && 'cf-badge--warn']">
    <slot />
  </span>
</template>

<script setup lang="ts">
// Deliberately not Seranova's TagItem: that is a dismissible tag with an ✕, a
// hover-darken, and required hex-colour props — built for editable chips like
// Job Tags, not for a read-only status word.
withDefaults(defineProps<{ tone?: "neutral" | "warn" }>(), {
  tone: "neutral"
});
</script>

<style scoped>
.cf-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  background: #f3f4f6;
  padding: 0.125rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1rem;
  color: #6b7280;
  white-space: nowrap;
}
.cf-badge--warn {
  background: #fef2f2;
  color: #b91c1c;
}
</style>
